<script>

export default {
  data() {
    return {
      activeTab: 1,
      items: [
        {
          id: 1,
          name: 'Personal Website',
          imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/MJDHNODO-1711590377666Pasted Graphic 1.png',
          status: '个人简介站.',
          tech: 'VueJS 3, Tailwind',
          github: 'null',
          demo: 'http://mywebsite.ssdwgg.cn/'
        },
        {
          id: 9,
          name: 'WGG BLOG',
          imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/PHFKHGNC-1711595226918WGG BLOG.png',
          status: '基于Dumi的文档框架，是WGG的前端知识总结博客库',
          tech: 'Dumi, Readme',
          github: 'https://github.com/SSDWGG/blog',
          demo: 'http://blog.ssdwgg.cn/'
        },
        {
          id: 5,
          name: 'MP_V2（个人中后台管理系统）',
          imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/EFANMBKF-1711591497556Pasted Graphic 6.png',
          status: '基于AntDesign_Pro的个人管理系统，包含有todoList等多种功能',
          tech: 'React, AntDesign_Pro',
          github: 'https://github.com/SSDWGG/MP_V2',
          demo: 'http://todo.ssdwgg.cn'
        },
        {
          id: 3,
          name: 'QKun',
          imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/JKLACABO-1711591320010Pasted Graphic 5.png',
          status: '基于Sakana物理引擎的Q坤坤',
          tech: 'React, Sakana',
          github: 'null',
          demo: 'http://ikunqqq.ssdwgg.cn'
        },
        {
          id: 10,
          name: '双人视频',
          imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/GJGIMFCL-1711595191478Pasted Graphic 12.png',
          status: '基于流媒体技术的双人视频通话验证型项目',
          tech: 'MRTK',
          github: 'null',
          demo: 'https://ssdwgg.cn:8693'
        },
        {
          id: 8,
          name: '兔子商城',
          imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/NAICMCGG-1711594579198Pasted Graphic 7.png',
          status: '基于vue和springboot的前后端分离电商平台型项目，包含从原型设计到验收文档的全套开源代码',
          tech: 'Vue2Js, Springboot',
          github: 'https://github.com/SSDWGG/rabbitMall',
          demo: 'http://mall.ssdwgg.cn'
        },
        {
          id: 4,
          name: 'WGGweb',
          imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/FBPKKKPM-1711591208241Pasted Graphic 4.png',
          status: '色彩鲜明的WGG个人项目合集',
          tech: 'Vue3Js',
          github: 'https://github.com/SSDWGG/WGGweb',
          demo: 'http://wgg.ssdwgg.cn'
        },
        {
          id: 2,
          name: 'Github',
          imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/KDLHCKEC-1711590640895Pasted Graphic 2.png',
          status: 'Github主页运营和搭建',
          tech: 'Html, Github',
          github: 'https://github.com/SSDWGG',
          demo: 'https://github.com/SSDWGG'
        },

        {
          id: 7,
          name: '诗文集卡片',
          imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/JOGBICGP-1711592412213Pasted Graphic 10.png',
          status: '流动的色彩鲜明的背景上收集着一些摘选诗文',
          tech: 'Vue',
          github: 'null',
          demo: 'http://poem.ssdwgg.cn'
        },
        {
          id: 6,
          name: '兔了个兔',
          imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/DHMLMDEP-1711592127292Pasted Graphic 9.png',
          status: '爆火的小游戏兔了个兔',
          tech: 'Vue3Js',
          github: 'null',
          demo: 'http://xlgx.ssdwgg.cn'
        },
        {
          id: 11,
          name: '人参果微信小程序',
          imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/JNKNICGF-1711595815871WechatIMG109.jpg',
          status: '基于Taro多端框架的个人微信小程序，内含有多种技术功能。欢迎微信搜索体验！',
          tech: 'Taro, Vue3Js, OSS...',
          github: 'null',
          demo: 'null'
        },
      ]
    };
  },

}
</script>
<template>
  <div class="px-5 py-5 md:px-12 md:py-10 text-left text-amber-50 mx-3">
    <article data-page="about">
      <header>
        <div
          class="text-2xl font-bold text-white mb-10 fadein-bot title-section flex items-center justify-center flex-col">

          <h4>Personal project</h4>
          <!--          <div class="h-[1px] w-10 bg-amber-200 md:w-20 aos-init aos-animate"></div>-->
          <h4 class="text-base font-normal text-transparent bg-clip-text bg-gradient-to-r from-slate-100 to-amber-300">
            Explore the open source projects I've worked on so far</h4>

        </div>
      </header>
      <section>
        <div>
          <div
            class="grid grid-cols-1 gap-4 pb-10 md:grid-cols-3 md:gap-3 xl:grid-cols-3 xl:gap-3 2xl:gap-5 fade-zoom-in">
            <div v-for="item in items" :key="item.id">
              <div
                class="item-card flex flex-col items-center gap-2 rounded bg-[#1e1e1f] hover:bg-[#282828] border border-[#383838] rounded-xl text-amber-50 md:gap-3 px-5 py-5 lg:px-5 ">
                <div class="flex h-12 w-12 items-center justify-center p-0 h-full w-full lg:p-0 zoom-in">
                  <img alt="HTML" loading="lazy" decoding="async" data-nimg="1" class="drop-shadow-xl rounded rounded-xl"
                    :src="item.imageUrl">
                </div>
                <div class="w-full flex flex-col gap-2 items-center text-sm md:text-base lg:text-lg">
                  <div class="title-text font-medium text-secondary">{{ item.name }}
                  </div>
                  <div class="w-full text-left text-[10px] text-[#c1c1c1] md:text-xs lg:text-sm">
                    {{ item.status }}
                  </div>
                  <div class="w-full mt-4 text-normal text-sm text-left text-amber-200">
                    {{ item.tech }}
                  </div>
                  <div class="w-full flex justify-end">
                    <div class="flex cursor-pointer items-end gap-2 text-primary">
                      <a v-if="item.github !== 'null'" :href="item.github" target="_blank" rel="noreferrer" title="查看源码"
                        class="transition-all hover:text-accent">
                        <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round"
                          stroke-linejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22">
                          </path>
                        </svg>
                      </a>
                      <a v-if="item.demo !== 'null'" :href="item.demo" target="_blank" rel="noreferrer" title="查看"
                        class="transition-all hover:text-accent">
                        <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round"
                          stroke-linejoin="round" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                          <polyline points="15 3 21 3 21 9"></polyline>
                          <line x1="10" y1="14" x2="21" y2="3"></line>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </article>
  </div>
</template>

<style>
.item-card:hover {
  transition: transform 0.3s ease;
  transform: translateY(-8px);
}

svg:hover {
  stroke: #ffdb70;
}

@keyframes fadeZoomIn {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Menggunakan animasi pada elemen yang diinginkan */
.fade-zoom-in {
  animation: fadeZoomIn 1s ease-in-out;
}
</style>
